import { render, staticRenderFns } from "./StockLocationChange.vue?vue&type=template&id=63b2c0ca&scoped=true&"
import script from "./StockLocationChange.vue?vue&type=script&lang=js&"
export * from "./StockLocationChange.vue?vue&type=script&lang=js&"
import style0 from "./StockLocationChange.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StockLocationChange.vue?vue&type=style&index=1&id=63b2c0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2c0ca",
  null
  
)

export default component.exports